export class ListGraphsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListGraphsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortGraphBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGraphsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
